import { useEffect } from 'react';
import { useAuth } from '../../store/auth';
import { toast } from '../../store/ui';

const IDLE_MS = 30 * 60_000; // SEC-06: 30 minute idle timeout (the server enforces it too)
const WARN_MS = 28 * 60_000;

/** Signs the user out after 30 idle minutes, with a warning two minutes before. */
export function useIdleLogout() {
  const logout = useAuth((s) => s.logout);
  useEffect(() => {
    let last = Date.now();
    let warned = false;
    const bump = () => {
      last = Date.now();
      warned = false;
    };
    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'] as const;
    events.forEach((e) => window.addEventListener(e, bump, { passive: true }));
    const timer = setInterval(() => {
      const idle = Date.now() - last;
      if (idle >= IDLE_MS) void logout({ expired: true });
      else if (idle >= WARN_MS && !warned) {
        warned = true;
        toast('You will be signed out in 2 minutes because of inactivity.');
      }
    }, 15_000);
    return () => {
      events.forEach((e) => window.removeEventListener(e, bump));
      clearInterval(timer);
    };
  }, [logout]);
}
